export const DENSITY_BREAK_MULTIPLIER = 500;

// Pixi 6 reported the empty body Sprite as 1x1, so every breakable received
// all four of the old size boosts. Keep that gameplay tuning explicitly
// instead of deriving physics strength from renderer bounds.
export const LEGACY_BREAK_IMPULSE_BOOST = 1.5 * 1.5 * 1.5 * 1.5;

export const adjustedBreakImpulse = (impulse, breakPenalty) => {
	if (breakPenalty) impulse *= breakPenalty;
	return impulse * LEGACY_BREAK_IMPULSE_BOOST;
};

export const exceedsBodyBreakThreshold = (impulse, density, breakPenalty) => (
	adjustedBreakImpulse(impulse, breakPenalty) > density * DENSITY_BREAK_MULTIPLIER
);
